import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import {
	AdvancedSearchFilterSourceEnum,
	TriggeredFromEnum,
	mapLocationToAdvancedSearchEnum,
} from 'functions/mappers/AdvancedSearch/mapLocationToAdvancedSearchEnum';
import { Optional } from 'functions/promiseExtensions';

export function callApi(
	searchTerm: string,
	showOnlyDeleted: boolean
): Promise<Optional<ResponseTag[]>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/Tag/StartingWith`;
	const params: Parameter = {
		SearchTerm: searchTerm,
		ShowOnlyDeleted: showOnlyDeleted,
	};
	if (mapLocationToAdvancedSearchEnum(TriggeredFromEnum.Tags)) {
		params.AdvancedSearchFilterSource = mapLocationToAdvancedSearchEnum(TriggeredFromEnum.Tags);
	}
	return axios
		.get(url, {
			params: params,
		})
		.toOptionalMapped((x) => x.data.tags);
}

interface Parameter {
	SearchTerm: string;
	ShowOnlyDeleted: boolean;
	AdvancedSearchFilterSource?: AdvancedSearchFilterSourceEnum | false;
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	tags: ResponseTag[];
};

export type ResponseTag = {
	id: string;
	name: string;
	iconSvgUrl: string;
	display: boolean;
	tagCategory: TagCategory;
};

export type TagCategory = {
	id: string;
	name: string;
};
